module.exports = __webpack_public_path__ + "img/border_line.a935cac1.svg";